import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook, MessageCircle } from 'lucide-react';

export const Footer = ({ onBookAppointment }) => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Virtual CFO Consultancy
            </h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              The client-facing advisory practice of NSRM & Associates — Chartered Accountants. We help SMEs, startups and family businesses with CFO-level financial expertise on a flexible retainer.
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <Mail className="w-5 h-5 text-emerald-400 mr-3" />
                <a href="mailto:info@nsrm.in" className="hover:text-emerald-400 transition-colors">info@nsrm.in</a>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 text-emerald-400 mr-3" />
                <a href="https://wa.me/919757231374" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors">+91 975-723-1374</a>
              </div>
              <div className="flex items-center">
                <MapPin className="w-5 h-5 text-emerald-400 mr-3" />
                <span>Mumbai | Bangalore | UAE</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/" className="hover:text-emerald-400 transition-colors">Home</a></li>
              <li><a href="/about" className="hover:text-emerald-400 transition-colors">About Us</a></li>
              <li><a href="/blogs" className="hover:text-emerald-400 transition-colors">Blog</a></li>
              <li><a href="/fdi" className="hover:text-emerald-400 transition-colors">FDI India Entry</a></li>
              <li><button onClick={onBookAppointment} className="hover:text-emerald-400 transition-colors">Book Consultation</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Virtual CFO Services</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">MIS Reporting</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">GST & Compliance</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Fundraising Support</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">International Tax</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} Virtual CFO Consultancy (NSRM & Associates). All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="https://in.linkedin.com/company/nsrm" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors"><Linkedin className="w-5 h-5" /></a>
              <a href="https://x.com/being_navratan" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors"><Twitter className="w-5 h-5" /></a>
              <a href="https://in.linkedin.com/company/nsrm" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-400 transition-colors"><Facebook className="w-5 h-5" /></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
